'use client';

import { usePathname } from 'next/navigation';
import { useEffect, useRef } from 'react';

export const WebPageViewLogger = () => {
  const pathname = usePathname();
  const lastPathname = useRef<string | null>(null);

  useEffect(() => {
    if (!pathname) return;

    const sendPageView = () => {
      void fetch('/api/access-log', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        referrerPolicy: 'no-referrer',
        keepalive: true,
        body: JSON.stringify({ pathname, viewedAt: new Date().toISOString() }),
      }).catch(() => undefined);
    };

    if (lastPathname.current !== pathname) {
      lastPathname.current = pathname;
      sendPageView();
    }

    const onPageShow = (event: PageTransitionEvent) => {
      if (event.persisted) sendPageView();
    };
    window.addEventListener('pageshow', onPageShow);
    return () => window.removeEventListener('pageshow', onPageShow);
  }, [pathname]);

  return null;
};
